export default function toFormData(data: Record<string, string | File>) {
    const formData = new FormData();
    
    for (const [key, val] of Object.entries(data))
        formData.append(key, val);

    return formData;
}